import { registerTranslation } from "@shoelace-style/localize";
const translation = {
  $code: "en",
  $name: "English",
  $dir: "ltr",
  close: "Close",
  loading: "Loading",
  badInput: "Not a valid URL format",
  typeMismatch: "Not a valid email format",
  patternMismatch: "Please match the requested format",
  rangeOverflow: (max, current) => `Please use no more than ${max} characters (you are currently using ${current} characters)`,
  rangeUnderflow: (min, current) => `Please use at least ${min} characters (you are currently using ${current} characters)`,
  valueMissing: "Please fill out this field",
  alert_info: "Important Information",
  alert_neutral: "Important Information",
  alert_warning: "Warning alert",
  alert_success: "Confirmation message",
  alert_error: "Error message",
  back_to_top: "Top",
  show: "Show",
  hide: "Hide"
};
registerTranslation(translation);
//# sourceMappingURL=en.js.map
